export class MenuItem {
  constructor(item = {}) {
    this.id = item.id;
    this.key = item.key;
  }
}
